import { hydrateRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router";
import routes from "@routes/index.jsx";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import "@css/index.css";
import { setRouter } from "@lib/utils";

if (location.pathname.indexOf('/en') === 0) {
    i18n.changeLanguage('en');
}

const router = createBrowserRouter(routes);
setRouter(router);
hydrateRoot(
    document.getElementById("root"),
    <I18nextProvider i18n={i18n}>
        <RouterProvider router={router} />
    </I18nextProvider>
);
